import React from 'react';
import img from '../core/assets/img/oops.svg';
import { Link as RouterLink} from 'react-router-dom';
import Button from '../core/components/Button';
import { Helmet } from 'react-helmet-async';
import {constants} from "../core/data/constants";
const SITIOWEBURL = constants[0].URL;
const WEBSITE = constants[0].websiteName;
const CONTENT = constants[0].mainContent;
const href = `${SITIOWEBURL}/404`;

// download from https://storyset.com/illustration/oops-404-error-with-a-broken-robot/rafiki#utm_source=freepik&utm_medium=referall&utm_campaign=storiesdetail&utm_content=edit-button&utm_term=edit
// and use some theme color
const Page404 = () => {
  return (
    <div className="grow flex flex-col justify-center items-center lg:px-32 px-5 
                  bg-background dark:bg-darkbackground text-text dark:text-darktext
                    duration-200 pt-16 md:pt-24 lg:pt-32  pb-12 text-center">
      <Helmet>
                <title>Página no encontrada | {WEBSITE}</title>
                <meta name="description" content={CONTENT}/>
                <link rel='canonical' href={href}/>
      </Helmet>
      <h1 className=" font-semibold  text-4xl mt-8">
        ¡Lo sentimos!
      </h1>
      <h2 className=" font-semibold text-xl lg:text-4xl mt-1">
        No pudimos encontrar esta página
      </h2>

    <img className='w-11/12 lg:w-1/3 mt-1'src={img} alt="Imagen Robot 404" />

    <p>Comprueba la URL de la página web e inténtalo de nuevo, o encuentra lo que buscas en nuestra página principal</p>

    <div className='mt-8 text-xl'>
      <RouterLink to={'/'} className="hover:text-primaryColor">
        <Button title="Página Principal"/>
      </RouterLink>
      
    </div>
    

   
    </div>

   
    
  )
}

export default Page404